var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CCard',[_c('CCardHeader',[_c('CIcon',{attrs:{"name":"cil-grid"}}),_vm._v(" Active Life Policies ")],1),_c('PoliciesTable')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }